import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/loading-icon.gif'
import _imports_1 from '@/assets/info.png'


const _hoisted_1 = {
  "data-testid": "step-waitingForPicture",
  class: "container"
}
const _hoisted_2 = { class: "container__standard-header" }
const _hoisted_3 = { class: "container__subheader t-center t-bold" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "row",
  style: { textAlign: 'center', marginTop: '-15px' }
}, [
  /*#__PURE__*/_createElementVNode("img", {
    "cy-data": "blackout",
    src: _imports_0,
    alt: "loading icon"
  })
], -1)
const _hoisted_5 = { class: "row row--waiting-for-the-picture" }
const _hoisted_6 = { class: "row row--information-about-refresh-website" }
const _hoisted_7 = { class: "row--info" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "image-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "info icon"
  })
], -1)
const _hoisted_9 = { class: "fs-12" }
const _hoisted_10 = { class: "fs-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NamedButton = _resolveComponent("NamedButton")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.personalDataHeader`)), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.waitingForPictureParagraph`)), 1),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_NamedButton, {
        disabled: !_ctx.isUploaded,
        class: "button width-for-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.next`)), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t(
                            `${_ctx.TRANSLATION_KEY}.informationAboutReloadingWebsite`
                        )), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.sendImageLater`)) + " ", 1),
        _createVNode(_component_SubmitButton, {
          "data-testid": "btn-waitingForPicture-skip",
          class: "link",
          action: _ctx.Action.ABORT_MOBILE,
          "cy-data": "abort"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.continueManually`) + ' »'), 1)
          ]),
          _: 1
        }, 8, ["action"])
      ])
    ])
  ]))
}